import { lookup } from '../modules/lookup-result-handler';

const initialize = () => {
    lookup('ns');
    lookup('mx');
    lookup('ownership_txt');
};

export default initialize;
